import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { ContractsService } from 'src/app/services/contracts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { VendorsService } from 'src/app/services/vendors.service';
import { VendorDto } from 'src/app/models/VendorDto';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { TokenService } from 'src/app/services/token.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExcelexportService } from 'src/app/services/excelexport.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { ManpowerapprovalService } from 'src/app/services/manpowerapproval.service';
import { ManPowerApprovalDto } from 'src/app/models/manpowerapproval-dto';
import * as FileSaver from 'file-saver';
import { ManpowerJDDto } from 'src/app/models/requests/ManpowerJDDto';
import { MovementPendingApprovalDto } from 'src/app/models/MovementPendingApprovalDto';
import { ManPowerPendingApprovalDto } from 'src/app/models/ManPowerPendingApprovalDto';
import { DocumentsService } from 'src/app/services/documents.service';

@Component({
  selector: 'app-view-manpower',
  templateUrl: './view-manpower.component.html',
  styleUrls: ['./view-manpower.component.css']
})
export class ViewManpowerComponent implements OnInit {
  currentUser: any;
  Requests: ManPowerDto[] = [];
  UpdateRequest: any;
  receivedfile: string = '';
  pdf:string="";
  isTerminationVisible: boolean = false;
  isShowCancelRequest: boolean = false;
  isChangeOkLoading = false;
  isShowRejectionMessage = false;
  canCreateManpower: boolean = false;
  isCloseModalVisible:boolean=false;
  closeModalTitle:string ="";
  ManPowerRequestApprovals: ManPowerApprovalDto[] | undefined;
  ManPowerPendingRequestApprovals: ManPowerPendingApprovalDto[] | undefined;
  ManPowerJD: ManpowerJDDto[] | undefined;
  canPrint: boolean = false;
  cancelComment:string="";
  filter: any
  ViewlevelOfCompliance = false;
  isCancelVisible:boolean=false;
  ViewManpowerRequestVisible = false;
  isPendingpprovalModalVisible = false;
  constructor(private router: Router, public datepipe: DatePipe, private manPowerService: ManPowersService, private notification: NotificationService,
    private vendorService: VendorsService, private manpowerApprovalService: ManpowerapprovalService,
    private tokenService: TokenService, private fb: FormBuilder, private documentService: DocumentsService) { }

  ngOnInit(): void {
    ;
    this.filter = history.state.data;
    this.loadRecords(this.filter);
    this.UserViews();
  }


  downloadExcel() {
    ;
    const exportData: Partial<object>[] = this.Requests.map(

      x => ({

        Reference: x.reference,
        Requester: x.createdBy,
        RequestDate: x.createdDate,
        Status: x.isActive ? 'Active' : 'Inactive',
        Designation: x.requesterDesignation,
        Function: x.requesterFunction,
        Unit: x.requesterUnit,
        Jobtitle: x.jobTitle,
        NPlus1Designation: x.nPlus1Designation,
        Band: x.band,
        CostCenter: x.costCenter,
        Location: x.location,
        DateVacancyOccurred: x.dateVacancyOccurred,
        RequiredNumber: x.requiredNumber,
        TypeOfVacancy: x.typeOfVacancy,
        ReasonForVacancy: x.reasonForVacancy,
        ModeOfRecruitment: x.modeOfRecruitment,
        DurationOfContract: x.durationOfContract,
        EstimatedAnnualCost: x.estimatedAnnualCost,
        CreatedBy: x.createdBy,
        justificationForVacancy: x.justificationForVacancy,
        Qualification: x.qualification,
        SkillsRequired: x.skillsRequired,
        Experience: x.experience,
        SystemRequired: x.systemRequired,
        OtherSystemRequirements: x.otherSystemRequirements,
        // isMedicalRequired
        // safetyInductionNotes

      })
    );
    ExcelexportService.exportArrayToExcel(exportData, 'Man Power Export')
  }


  async open(data: ManPowerDto) {
    ;
    this.ViewManpowerRequestVisible = true;
    this.UpdateRequest = data;

    this.currentUser = this.tokenService.getInfo();
    if (data.status === "Approved") { this.canPrint = true }
    let resApprovals = await this.manpowerApprovalService.getRequestApprovals(data.id).toPromise();
    this.ManPowerRequestApprovals = <ManPowerApprovalDto[]>resApprovals.responseData;

    this.UpdateRequest = data;

    if (data.status === "Approved") { this.canPrint = true }

    // if (data.status === "Active") { this.canPrint = true; this.canTerminate = true }

    if ((this.currentUser.profile.email == 'gbemiga.owolabi@ng.huaxin.com' || this.currentUser.profile.email == 'lolu.akinyemi@ng.huaxin.com')) { this.ViewlevelOfCompliance = true; }


  }


  async openapproval(data: ManPowerDto) {
    ;

    //this.UpdateRequest = data;
    this.UpdateRequest = data;
    let resApprovals = await this.manPowerService.getPendingRequestApprovals(data.id).toPromise();
    this.ManPowerPendingRequestApprovals = <ManPowerPendingApprovalDto[]>resApprovals.responseData;

    this.isPendingpprovalModalVisible = true;
    // if (data.status === "Active") { this.canPrint = true; this.canTerminate = true }

  }
  async loadRecords(filter: any) {
    ;
    this.currentUser = this.tokenService.getInfo(); 
    let resRequests = await this.manPowerService.getManPower().toPromise();
    this.Requests = <ManPowerDto[]>resRequests.responseData;

    for (const request of resRequests.responseData) {
      ;
      if ((request.createdBy == this.currentUser.profile.email)) { this.isShowCancelRequest = true; }
      if (request.rejectionMessage == 'Yes') {
        this.isShowRejectionMessage = true
      }
    }
    

    try {
      this.Requests?.sort((n1, n2) => {
        if (n1.id > n2.id) {
          return -1;
        }

        return 0;
      });
    } catch (error) {

    }

  }
  UserViews(): void {

    try {

      ;
      const userData: LoginResponseData = this.tokenService.getInfo();
      var UserPermission = userData.permission;

      const ContractPerm = UserPermission.find((obj) => {
        return obj.permissionName === "Manpower";
      });

      if (ContractPerm) {
        this.canCreateManpower = ContractPerm.canAdd === true ? true : false;
       
      }


    }
    catch (e: unknown) { }


  }

  cancelRequest(){

    ;
    this.isChangeOkLoading=true;
    if (this.cancelComment === '') 
    {
      this.notification.sendMessage({
        message: 'Comment is required to close request',
        type: NotificationType.error
      });
      this.isChangeOkLoading=false;
    }
    else {
      this.isChangeOkLoading = true;
      const data =
      {
        id: this.UpdateRequest.id,
        message: this.cancelComment,
 

      }

      this.manPowerService.CancelRequest(data).subscribe({
        next: (data => {
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });
            this.loadRecords(this.filter)
            this.isTerminationVisible = false;
            this.close()
            
          }
          else {

            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });

            this.isChangeOkLoading = false;
          }

        }),
        error: ((error: any) => {
          console.log(error.error);

          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });

          this.isChangeOkLoading = false;
        })

      });}

  }
  handleCancel(): void {
    this.isPendingpprovalModalVisible = false;
    this.isCancelVisible = false;
    
  }
  
  handleText(): void {
    this.isPendingpprovalModalVisible = false;

  }

  
  async beginCancel(data: ManPowerDto) 
  {
    ;
    this.closeModalTitle="Cancel Contract ";
     this.isCloseModalVisible = true;
     this.isCancelVisible = true;
   this.UpdateRequest=data;
  }
  
async handleSubmit() {
 ;
     var obj:any = {}
    obj.NextApprovalEmail = this.UpdateRequest.nextToApprove;
    obj.RequestId = this.UpdateRequest.id;

    let resRequests = await this.manPowerService.SendManualReminder(obj).toPromise();
    this.Requests = <ManPowerDto[]>resRequests.responseData;
     this.notification.sendMessage({
        message: resRequests.message,
        type: NotificationType.success
      });
      this.isPendingpprovalModalVisible = false;

  }

  print(requestReference:string, templateId:string) {
    
    this.documentService.DownloadPDF(templateId, `Manpower Request - ${requestReference}`);
  }
  cancel(): void {
    return;
  }


  close(): void {
    this.ViewManpowerRequestVisible = false;
    this.canPrint = false;

  }

  async getJD(datas: ManPowerDto) {
    // this.ViewManPowerVisible = true;
    ;
    this.UpdateRequest = datas;
    let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
    ;

    this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;
    var receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64,", "")
    const b = Uint8Array.from(atob(receivedfile), c => c.charCodeAt(0));
    const blob = new Blob([b], { type: "application/octet-stream" });
    FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);

  }

  
  async showDocument(datas: ManPowerDto){
    // this.open();
    ;
    let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
       ;
     
       this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;
     
        this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
        this.pdf = getJDRequest.responseData[0].documentContent
     
       // this.PathReportString = 'data:application/pdf;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.receivedfile) as any).changingThisBreaksApplicationSecurity;
              
       // top!.document.getElementById('ifrm')!.setAttribute("src", this.PathReportString)!;
       const pdfWindow = window.open("")!;    
       pdfWindow.document.write("<html<head><title>Additional Report</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");    
       pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +    
       encodeURI(this.receivedfile) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>") 
   
   
   }

  getStatusColor(status: string): string {
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
      case "Closed":
        return 'badge badge-danger';
      case "Cancelled":
        return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }


  getColor(status: string): string {
    switch (status) {
      case "MEDIUM":
        return 'badge badge-warning';
      case "LOW":
        return 'badge badge-success';
      case "HIGH":
        return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }

}